:host .producer-card {
  font-family: 'Helvetica Now Text', sans-serif;
  display: flex;
  flex-direction: column;
  gap: 32px
}
